/* eslint-disable no-param-reassign,class-methods-use-this */
import { Presence } from 'phoenix';
import { DISABLE_LOGS } from '../../../constants/env';

/* eslint-disable immutable/no-mutation */
export default class AbstractChannel {
  _joinChannel(socket, channelId, timeout = 60000) {
    this.channelId = channelId;
    this.channel = socket.channel(this.channelId);

    this._addListeners();
    this._handleJoin(this.channel.join(timeout));
  }

  _handleJoin(joining) {
    joining.receive('ignor', () => {
      if (DISABLE_LOGS) {
        return;
      }

      console.error(`-- JOIN ${this.channelId}... Auth error!`);
    });
    joining.receive('ok', () => {
      if (DISABLE_LOGS) {
        return;
      }
      console.log(`-- JOIN ${this.channelId}... OK!`);
    });
  }

  _logAction(action, payload) {
    if (DISABLE_LOGS) {
      return;
    }
    console.log('--', action, this.channelId, payload);
  }

  _trackPresence() {
    this.channel.on('presence_state', data =>
      this._onRecievePresenceState(data),
    );
    this.channel.on('presence_diff', data => this._onRecievePresenceDiff(data));
  }

  _onRecievePresenceState(data) {
    this.presence = Presence.syncState(this.presence, data);
    this._render();
  }

  _onRecievePresenceDiff(data) {
    this.presence = Presence.syncDiff(this.presence, data);
    this._render();
  }

  _listBy(
    id,
    {
      metas: [first],
    },
  ) {
    first.username = first.name;
    first.id = id;

    return first;
  }

  _render() {
    Presence.list(this.presence, this._listBy).each(
      user => `${user.username} @ ${this.channelId} get online!`,
    );
  }
}
/* eslint-enable immutable/no-mutation */



// WEBPACK FOOTER //
// ./src/utils/chatAPI/channels/abstract_channel.js